'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var BrokerLeadCardNotice = require('./BrokerLeadCardNotice.js');
var react = require('@chakra-ui/react');
var React = require('react');
var utils = require('@chakra-ui/utils');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var _excluded = ["className"];

/**
 * BrokerLeadCardOverdue
 *
 * Used to display the overdue state on the right inside the header.
 */
var BrokerLeadCardOverdue = react.forwardRef(function (props, ref) {
  var className = props.className,
    rest = _objectWithoutProperties__default["default"](props, _excluded);
  var styles = react.useStyles();
  return /*#__PURE__*/React__default["default"].createElement(BrokerLeadCardNotice.BrokerLeadCardNotice, _extends__default["default"]({
    __css: styles.overdue
  }, rest, {
    className: utils.cx('chakra-broker-lead-card__overdue', className),
    ref: ref
  }));
});
BrokerLeadCardOverdue.displayName = 'BrokerLeadCardOverdue';
exports.BrokerLeadCardOverdue = BrokerLeadCardOverdue;